import API from "src/core/Api";
import { store } from '../store'

export default {
    objectIsEmpty: (obj) => {
        for(let prop in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if(obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    },
    currencyFormat: (amount) => {
        // Create our number formatter.
        var formatter = new Intl.NumberFormat('en-ES', {
            style: 'currency',
            currency: 'GTQ',

            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });

        return formatter.format(amount);
    },
    copyToClipboard: (text, msg) => {

        if (!msg) msg = 'Copiado al portapapeles con éxito';
        //var text = "Example text to appear on clipboard";
        navigator.clipboard.writeText(text).then(function() {
            API.showSuccessNotify(msg);
        }, function() {
            API.showSuccessNotify('Error al copiar, el navegador no es compatible');
        });
    },
    pushToObject(object, data) {
        const tmp = {};
        let count = 0;
        for (let item in object) {
            tmp[count] = object[item];
            count++;
        }
        tmp[count] = data;
        return tmp;
    },
    stringCapitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    createSlug(string) {
        //return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0).toLowerCase() + string.slice(1);
        return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/(?!\w|\s)./g, '-').replace(/\s+/g, '-').replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2').toLowerCase();
    },
    isEmptyString(str, strLen) {
        if (!strLen) {
            return (str === null || str.match(/^ *$/) !== null || str === '');
        }
        else {
            return ((str === null || str.match(/^ *$/) !== null || str === '') || (str.length < strLen));
        }
    },
    checkPasswordStrength(password) {
        //Regular Expressions
        const regex = [];
        regex.push("[A-Z]"); //For Uppercase Alphabet
        regex.push("[a-z]"); //For Lowercase Alphabet
        regex.push("[0-9]"); //For Numeric Digits
        regex.push("[$@$!%*#?&-.;=+]"); //For Special Characters

        let passed = 0;

        //Validation for each Regular Expression
        for (var i = 0; i < regex.length; i++) {
            if ((new RegExp(regex[i])).test(password)) {
                passed++;
            }
        }

        //Validation for Length of Password
        if (passed > 2 && password.length > 8) {
            passed++;
        }

        //Display of Status
        let color = "";
        let passwordStrength = "";
        switch (passed) {
            case 0:
                break;
            case 1:
                passwordStrength = "La contraseña es débil";
                color = "#d72d2d";
                break;
            case 2:
                passwordStrength = "La contraseña es débil";
                color = "darkorange";
                break;
            case 3:
                passwordStrength = "La contraseña es débil";
                break;
            case 4:
                passwordStrength = "La contraseña es fuerte";
                color = "Green";
                break;
            case 5:
                passwordStrength = "La contraseña es muy fuerte";
                color = "darkgreen";
                break;
        }

        return {
            passwordStrength: passed,
            passwordStrengthMsg: passwordStrength,
            passwordStrengthColor: color,
        }
    },

    // para check de accesos y configuraciones
    check: {
        config(module, key) {
            const config = (store.getters.AuthGetUserInfo.configuration) ? store.getters.AuthGetUserInfo.configuration : {};
            if (typeof config[module] !== 'undefined') {
                if (typeof config[module][key] !== 'undefined') {
                    return config[module][key];
                }
            }
            return false;
        },
        access() {

        },
    },

    pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    },

    checkAccess(stringAccess) {
        const config = (store.getters.AuthUserAccess) ? store.getters.AuthUserAccess : {};
        if (typeof config[stringAccess] !== 'undefined') {
            return true;
        }
        else {
            return false;
        }
    },

    tieneParamsBusquedaRuta(params) {
        if (!params) {
            return false;
        }
        const {type, search} = params;
        if (!type || typeof search === 'undefined' || search === null || search === '0') {
            return false;
        }
        return !this.isEmptyString(String(search).trim());
    },
}
